import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  DictionaryItem,
  DictionaryPageResult,
  DictionaryPayload,
  DictionaryQueryParams,
} from './types/dictionary';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/areas';

export async function queryAreas(
  params: DictionaryQueryParams,
  options?: ApiRequestOptions,
) {
  return request<DictionaryPageResult>(BASE_PATH, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function createArea(payload: DictionaryPayload, options?: ApiRequestOptions) {
  return request<DictionaryItem>(BASE_PATH, {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateArea(
  uuid: string,
  payload: DictionaryPayload,
  options?: ApiRequestOptions,
) {
  return request<DictionaryItem>(`${BASE_PATH}/${uuid}`, {
    method: 'PATCH',
    data: payload,
    ...(options || {}),
  });
}

export async function deleteArea(uuid: string, options?: ApiRequestOptions) {
  return request<void>(`${BASE_PATH}/${uuid}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}
